import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { Check, X } from "lucide-react";

const rows = [
  { dim: "Your space", sons: "Reserved private cabana", public: "First-come picnic table" },
  { dim: "Crowds", sons: "Capacity-limited island", public: "Packed shoreline, no buffer" },
  { dim: "Dock access", sons: "Private dock at your cabana", public: "Public ramp, shared" },
  { dim: "Cook setup", sons: "Charcoal BBQ + picnic table", public: "Bring your own or none" },
  { dim: "Group size", sons: "Entry for 8, up to 15", public: "Whoever shows up next to you" },
  { dim: "Parking", sons: "Free, included for 2 cars", public: "Hunt for spots, paid" },
];

const WhyPrivateMatters = () => {
  return (
    <section className="py-20 lg:py-28 bg-background">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Why Private Island Matters: Son's Island vs. Public Texas Lake Parks",
          "itemListElement": rows.map((r, i) => ({
            "@type": "ListItem",
            "position": i + 1,
            "name": r.dim,
            "description": `Son's Island: ${r.sons}. Public park: ${r.public}.`,
          })),
        })}</script>
      </Helmet>
      <div className="container max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Why Private Matters
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            How a private 3.5-acre island compares to a crowded public Texas lake park.
          </p>
        </motion.div>

        <div className="overflow-hidden rounded-2xl border border-border bg-card">
          <table className="w-full text-left">
            <thead className="bg-muted">
              <tr>
                <th className="p-4 font-display font-semibold text-foreground text-sm md:text-base">What you get</th>
                <th className="p-4 font-display font-semibold text-primary text-sm md:text-base">Son's Island (Private)</th>
                <th className="p-4 font-display font-semibold text-muted-foreground text-sm md:text-base">Public Lake Park</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.dim} className="border-t border-border">
                  <td className="p-4 font-medium text-foreground text-sm md:text-base">{row.dim}</td>
                  <td className="p-4 text-sm md:text-base">
                    <span className="inline-flex items-start gap-2 text-foreground">
                      <Check className="w-4 h-4 text-accent mt-1 flex-shrink-0" />
                      {row.sons}
                    </span>
                  </td>
                  <td className="p-4 text-sm md:text-base">
                    <span className="inline-flex items-start gap-2 text-muted-foreground">
                      <X className="w-4 h-4 text-destructive/70 mt-1 flex-shrink-0" />
                      {row.public}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default WhyPrivateMatters;